import { FC } from 'react';
import DropdownSyncTable from '../DropdownSyncTable';
import SearchFormItem from './subpage/searchFormItem';
import { getSelectPlaceholder } from '../utils/ruleUtils';
import { DropdownSyncTableProps } from '../DropdownSyncTable/interface';
import {
  BaseSearchFormItemProps,
  SearchFormItemEnum,
} from './interface/baseInterface';

export interface SearchFormDropdownSyncTableProps extends BaseSearchFormItemProps {
  /** dropdownSyncTable Props */
  dropdownSyncTableProps?: DropdownSyncTableProps;
}
/** 异步下拉表格 */
export const SearchFormDropdownSyncTable: FC<SearchFormDropdownSyncTableProps> = props => {
  const {
    dropdownSyncTableProps,
    isDetail,
    form,
    render,
    disabledRender,
    isTable,
    name,
    testId,
    label,
    rules,
    copy,
    ...resProps
  } = props;
  return (
    <SearchFormItem
      {...resProps}
      disabled={isDetail || dropdownSyncTableProps?.disabled}
      name={name}
      label={label}
      rules={rules}
      validateTrigger="onChange"
    >
      <DropdownSyncTable
        allowClear
        showSearch
        test-id={`${testId}-${name}`}
        disabledRender={render || disabledRender}
        {...dropdownSyncTableProps}
        disabled={isDetail || dropdownSyncTableProps?.disabled}
        placeholder={getSelectPlaceholder(label, dropdownSyncTableProps, rules)}
      />
    </SearchFormItem>
  );
};

SearchFormDropdownSyncTable.displayName = SearchFormItemEnum.SearchFormDropdownSyncTable;

export default SearchFormDropdownSyncTable;
